import { Grid, withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import CustomSelectNew from "../../components/UpdateUi/CustomeSelect";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import { Button } from "@material-ui/core";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import ConfirmationModal from "views/components/ConfirmationModal";
import axios from "axios";
import SchemeChargesDetails from "./SchemeChargesDetails";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { criteriaBaseData } from "assets/properties/properties";
import { useOutletContext } from "react-router-dom";
import { parseAndSetFlag } from "utils/Utils";
import { chargeNatureList } from "assets/properties/properties";
import { chargesNameList } from "assets/properties/properties";
const SchemeCharge = ({
  classes,
  chargeNameState,
  setChargeNameState,
  setChargeNatureState,
  chargeNatureState,
  chargeTypeState,
  setChargeTypeState,
  valueSetState,
  setValueSetState,
  minAmountState,
  setMinAmountState,
  maxAmountState,
  setMaxAmountState,
  criteriaTypeState,
  setCriteriaTypeState,
  criteriaAmountState,
  setCriteriaAmountState,
  groupDetails,
  setGroupDetails,
  setLastIndex,
  lastIndex,
  editMode,
  viewPage,
  setId,
  id,
  editScheme,
  schemeChargeLength,
  chargesApiList,
  minPercentageState,
  setMinPercentageState,
  maxPercentageState,
  setMaxPercentageState,
  enabledMinMAxPercentageFieldsCharges,
  outletData,
}) => {
  const [editIndex, setEditIndex] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const enabledGstApplicationForAllCharges = parseAndSetFlag(outletData?.enabledGstApplicationForAllCharges);
  const addNextRow = () => {
    let newIndex = lastIndex + 1;
    setLastIndex(newIndex);
    let newArr = [...groupDetails]; // copying the old datas array
    newArr[newIndex] = {
      id: newIndex,
      name: "",
      disabledName:false,
      chargeNature: "",
      disabledChargeNature: false,
      chargeType: "",
      disabledChargeType: false,
      value: "",
      disabledValue: false,
      minAmt: "",
      disabledMinAmt: false,
      maxAmt: "",
      disabledMaxAmt: "",
      criteriaType: "",
      criteriaAmt: "",
      disabledCriteriaAmt: false,
      disbursalTime: false,
      loanSchemeId: "",
      loanSchemeCode: "",
      gstApplicable: true,
      excludingGst: true,
      chargeDetails: [],
      graceDays: 0,
      data:{CRITERIA_BASE:'',PROCESSINGFEE_PERCENTAGE:{MIN_PERCENTAGE:"",MAX_PERCENTAGE:""}},
      disabledCriteriaBase:false,
    };
    setGroupDetails(newArr);
  };
  const addChargesData = (indexGroup, newIndex) => {

    let newArr = [...groupDetails];
    let chargeDetailsArray = [...newArr[indexGroup].chargeDetails];
    // Add a new object to chargeDetailsArray
    chargeDetailsArray[newIndex] = {
      days: newIndex === 0
      ? `${30}`
      : `${newIndex * 30 + 30}`,
      chargeNature: "",
      value: "",
      minAmt: "",
      maxAmt: "",
      chargeNatureError: false,
      valueError:false,
      minAmountError:false,
      maxAmountError:false,
    };
    newArr[indexGroup] = {
      ...newArr[indexGroup], // Copy other properties from the existing object
      chargeDetails: chargeDetailsArray, // Update the chargeDetails array
    };
    setGroupDetails(newArr);
  };
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const enableProcessingFeeCriteriaTypeFlag = parseAndSetFlag(outletData?.enableProcessingFeeCriteriaType)
  const deleteRow = (i) => {
    if (editMode) {
      setConfirmationModalHeader("Delete Charge");
      setConfirmationModalMsg("Are you sure you want to delete this Charges");
      setConfirmationModal(true);
      setDeleteId(i);
    } else {
      setLastIndex(lastIndex - 1);
      setGroupDetails((prev) => prev.filter((p, j) => i !== j));
    }
  };
  const handleChange = (e, i, label, chargeIndex) => {
    const regex = /^\d*\.?\d*$/;
    let newArr = [...groupDetails];
    let item = newArr[i];
    if (label === "Charges") {
      const filteredCharges = chargesApiList.filter(
        (charge) => charge.name === e
      );
      if (filteredCharges.length > 0) {
        const charge = filteredCharges[0];
        if (charge.name === "PREPAYMENT") {
          item = {
            ...item,
            name: charge.name,
            chargeType: charge.name,
            criteriaType: "PART_PAYMENT_AMOUNT",
            disbursalTime: false,
            disabledName:false,
          };

        } else if (charge.name === "CUSTODY" || charge?.name === "PENAL_CHARGE_LTV") {
          item = {
            ...item,
            name: charge.name,
            chargeType: charge.name,
            criteriaType: "LTV",
            disbursalTime: false,
            disabledName:false,
          };
        } else if (
          charge.name === "CASH_DISBURSAL" ||
          charge.name === "PROCESSING_FEE"
        ) {
          item = {
            ...item,
            name: charge.name,
            chargeType: charge.name,
            disbursalTime: false,
            disabledName:false,
          };
        } else {
          let value =
            charge.name === "CLOSURE_OWN_FUND" ||
            charge.name === "CLOSURE_BT" ||
            charge.name === "CLOSURE_TOPUP"
              ? "CLOSURE"
              : charge.type;
          item = {
            ...item,
            name: charge.name,
            chargeType: value,
            disbursalTime: false,
            disabledName:false,
          };
        }
      } else {
        item = {
          ...item,
          name: e,
          chargeType: e,
          disbursalTime: false,
          disabledName:false,
        };
      }
    }
    if(label === "chargeDetailsNature"){
    const updatedChargeDetails = item.chargeDetails.map((chargeDetail, index) => {
      if (index === chargeIndex && e==="FLAT" && chargeDetail?.value) {
        return { ...chargeDetail, chargeNature: e,minAmt:chargeDetail?.value,maxAmt:chargeDetail?.value, chargeNatureError:false };
      }else if(index === chargeIndex && e==="PERCENTAGE" ){
        return { ...chargeDetail, chargeNature: e,minAmt:"",maxAmt:"", chargeNatureError:false };
      }else if(index === chargeIndex) {
        return { ...chargeDetail, chargeNature: e, chargeNatureError:false };
      }
      return chargeDetail;
    });
    item = { ...item, chargeDetails: updatedChargeDetails};
  }
  if(label === "chargeMinAmount"){
    const updatedChargeDetails = item.chargeDetails.map((chargeDetail, index) => {
      if (index === chargeIndex) {
        if (e === "" || regex.test(e)) {
        return { ...chargeDetail, minAmt: e, minAmountError: false};
        }
      }
      return chargeDetail;
    });
    item = { ...item, chargeDetails: updatedChargeDetails};
  }
  if(label === "chargeMaxAmount"){
    const updatedChargeDetails = item.chargeDetails.map((chargeDetail, index) => {
      if (index === chargeIndex) {
        if (e === "" || regex.test(e)) {
        return { ...chargeDetail, maxAmt: e, maxAmountError:false};
        }
      }
      return chargeDetail;
    });
    item = { ...item, chargeDetails: updatedChargeDetails };
  }

  if(label === "chargeValue"){
    const updatedChargeDetails = item.chargeDetails.map((chargeDetail, index) => {
      if (index === chargeIndex && item.chargeDetails[index]?.chargeNature === "FLAT") {
        if (e === "" || regex.test(e)) {
        return { ...chargeDetail, value: e , minAmt: e, maxAmt: e, valueError:false, minAmountError:false, maxAmountError:false };
        }
      }else if (index === chargeIndex && item.chargeDetails[index]?.chargeNature === "PERCENTAGE") {
        if (e === "" || regex.test(e)) {
        return { ...chargeDetail, value: e  ,valueError:false};
        }
      }return chargeDetail;
    });
    item = { ...item, chargeDetails: updatedChargeDetails };
  }
    if (label === "ChargeNature" && e === "PERCENTAGE") {
      item = { ...item, chargeNature: e, value: "", minAmt: "", maxAmt: "" ,disabledChargeNature:false};
    }
    if (label === "ChargeNature") {
      item = { ...item, chargeNature: e,disabledChargeNature:false};
    }
    if(label === "Grace Days"){
      item = { ...item, graceDays: e};
    }
    if (label === "Value" && groupDetails[i].chargeNature === "FLAT") {
      if (e === "" || regex.test(e)) {
        item = { ...item, value: e, minAmt: e, maxAmt: e ,disabledValue:false,disabledMinAmt:false,disabledMaxAmt:false};
      }
    }
    if (label === "Value") {
      if (e === "" || regex.test(e)) {
        item = { ...item, value: e,disabledValue:false};
      }
    }
    if (label === "MinAmount") {
      if (e === "" || regex.test(e)) {
        item = { ...item, minAmt: e,disabledMinAmt:false};
      }
    }
    if (label === "MaxAmount") {
      if (e === "" || regex.test(e)) {
        item = { ...item, maxAmt: e ,disabledMaxAmt:false};
      }
    }
    if (label === "CriteriaType") {
      item = { ...item, criteriaType: e };
    }
    if (label === "CriteriaType" && e === "SELECT") {
      item = { ...item, criteriaType: "" };
    }
    if (label === "Criteria") {
      if (e === "" || regex.test(e)) {
        item = { ...item, criteriaAmt: e,disabledCriteriaAmt:false};
      }
    }
    if (label === "Checked") {
      item = { ...item, disbursalTime: e };
    }
    if (label === "GSTChecked") {
      item = { ...item, gstApplicable: e };
    }
    if (label === "excludeGst") {
      item = { ...item, excludingGst: e };
    }
   if (label === "Criteria Base") {
      item = { 
        ...item, 
        data: { 
          ...item.data, 
          CRITERIA_BASE: e 
        }, 
        disabledCriteriaBase: false 
      };
    }
    if (label === "Min Percentage") {
      item = { 
        ...item, 
        value:0,
        data: { 
          ...item.data, 
          PROCESSINGFEE_PERCENTAGE:{...item.data.PROCESSINGFEE_PERCENTAGE,MIN_PERCENTAGE: e} 
        }
      };
    }
    if (label === "Max Percentage") {
      item = { 
        ...item, 
        value:0,
        data: { 
          ...item.data, 
          PROCESSINGFEE_PERCENTAGE:{...item.data.PROCESSINGFEE_PERCENTAGE,MAX_PERCENTAGE: e}
        }
      };
    }
    newArr[i] = item;
    setGroupDetails(newArr);
  };
  const editRow = (i) => {
    setEditIndex(i);
  };
  const deleteCharge = async (i) => {
    const URL =
      endpoint.BASE_URL_STAGING + "/" + endpoint.ADMIN_SCHEME_CHARGE_DELETE;
    const result = await axios.delete(URL + groupDetails?.[i]?.id, {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Scheme Charge Delete Successfully", true);
      editScheme();
    }
  };
  const processingFeevPercentageValidation = (i)=>{
  if(groupDetails?.[i]?.chargeType === "PROCESSING_FEE" && enabledMinMAxPercentageFieldsCharges && groupDetails?.[i]?.chargeNature === "PERCENTAGE" && groupDetails?.[i]?.value === 0 ){
    const minPerCentage = groupDetails?.[i]?.data?.PROCESSINGFEE_PERCENTAGE?.MIN_PERCENTAGE;
    const  maxPerCetnage = groupDetails?.[i]?.data?.PROCESSINGFEE_PERCENTAGE?.MAX_PERCENTAGE;
      if(minPerCentage === ""  && maxPerCetnage >=0){
            toastUpdate("Error", "Please Add Min Percentage", true)  
                return false
      }else if(minPerCentage >=0 && (maxPerCetnage === "" || maxPerCetnage < minPerCentage )){
        const errorMsg = maxPerCetnage < minPerCentage && maxPerCetnage > 0 ? "Max Percentage Should Be Greather Than Min Percentage" : "Please Add Max Percentage";
        toastUpdate("Error", errorMsg, true)  
        return false
      }else{
        return true
      }

    }else{
      return true
    }
  }
  const createCharge = async (i) => {
    const newArray = groupDetails?.length - 1;
    if(isValidated(newArray) && processingFeevPercentageValidation(i)){
      setCallInProgress(true);
      const schemeChargesArr = removeDisabledAndErrorFields(groupDetails);
        let dataCriteria = {
        CRITERIA_BASE: schemeChargesArr?.[i]?.data?.CRITERIA_BASE
      };
      if (schemeChargesArr?.[i]?.chargeType === "PROCESSING_FEE" && enabledMinMAxPercentageFieldsCharges && schemeChargesArr?.[i]?.chargeNature === "PERCENTAGE" && Number(schemeChargesArr?.[i]?.value) <= 0) {
        const min = schemeChargesArr?.[i]?.data?.PROCESSINGFEE_PERCENTAGE?.MIN_PERCENTAGE || 0;
        const max = schemeChargesArr?.[i]?.data?.PROCESSINGFEE_PERCENTAGE?.MAX_PERCENTAGE || 0;
      
        dataCriteria.PROCESSINGFEE_PERCENTAGE = {
          MIN_PERCENTAGE: parseFloat(min),
          MAX_PERCENTAGE: parseFloat(max)
        };
      } else {
          delete dataCriteria.PROCESSINGFEE_PERCENTAGE;
      }
    const result = await apiHandler({
      url: endpoint.ADMIN_SCHEME_CHARGE_CREATE,
      method: "POST",
      authToken: authToken,
      data: {
        name: schemeChargesArr[newArray]?.name,
        chargeNature: schemeChargesArr[newArray]?.chargeNature,
        chargeType: schemeChargesArr[newArray]?.chargeType,
        value: schemeChargesArr[newArray]?.value,
        minAmt:
          schemeChargesArr[newArray]?.chargeNature === "FLAT"
            ? Number(schemeChargesArr[newArray]?.value)
            : schemeChargesArr[newArray]?.minAmt,
        maxAmt:
          schemeChargesArr[newArray]?.chargeNature === "FLAT"
            ? Number(schemeChargesArr[newArray]?.value)
            : schemeChargesArr[newArray]?.maxAmt,
        criteriaType: schemeChargesArr?.[newArray]?.chargeType === "CUSTODY" ||
        schemeChargesArr?.[newArray]?.chargeType === "PREPAYMENT" ||
        schemeChargesArr?.[newArray]?.chargeType === "PENAL_CHARGE_LTV" ? schemeChargesArr[newArray]?.criteriaType : "",
        criteriaAmt: schemeChargesArr?.[newArray]?.chargeType === "CUSTODY" ||
        schemeChargesArr?.[newArray]?.chargeType === "PREPAYMENT" ||
        schemeChargesArr?.[newArray]?.chargeType === "PENAL_CHARGE_LTV" ? schemeChargesArr[newArray]?.criteriaAmt : "",
        disbursalTime: schemeChargesArr[newArray]?.disbursalTime,
        gstApplicable: schemeChargesArr[newArray]?.gstApplicable,
        excludingGst: schemeChargesArr[newArray]?.excludingGst,
        loanSchemeCode: editMode,
        loanSchemeId: id,
        chargeDetails: schemeChargesArr[newArray]?.chargeDetails,
        graceDays: schemeChargesArr?.[newArray]?.chargeType === "PENAL_CHARGE_LTV" ? Number(schemeChargesArr[newArray]?.graceDays) : 0,
        data:dataCriteria
      },
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Scheme Charge Update Successfully", true);
      editScheme();
      setEditIndex("");
    }
  }
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
  };

  const handlePositiveResponse = async () => {
    handleNegativeResponse();
    // Call API to delete Charges
    deleteCharge(deleteId);
  };
  const isValidated = (i) => {
    let isValid = true;

    if (groupDetails?.length > 0) {
      const hasDuplicate = groupDetails.some((item, index) => {
        return index !== i && item.name === groupDetails?.[i]?.name;
      });

      if (hasDuplicate) {
        toastUpdate("Error", "Charge Type already exists", true);
        isValid = false;
      }
    }

  if (isValid) {

    if (
      (groupDetails?.[i]?.chargeType === "CUSTODY" ||
        groupDetails?.[i]?.chargeType === "PREPAYMENT" || groupDetails?.[i]?.chargeType === "PENAL_CHARGE_LTV") &&
      !groupDetails?.[i]?.criteriaType
    ) {
      setCriteriaTypeState(true);
      return;
    } else {
      setCriteriaTypeState(false);
    }
    if (
      (groupDetails?.[i]?.chargeType === "CUSTODY" ||
        groupDetails?.[i]?.chargeType === "PREPAYMENT" || groupDetails?.[i]?.chargeType === "PENAL_CHARGE_LTV") &&
      !groupDetails?.[i]?.criteriaAmt
    ) {
      setCriteriaAmountState(true);
      return;
    } else {
      setCriteriaAmountState(false);
    }
    const updatedGroupDetails = groupDetails.map((item,index) => {
      if (i === index ) {
        item.disabledName = item?.name?.toString()?.trim() === "";
        item.disabledChargeNature = item?.chargeNature?.toString()?.trim() === "";
        item.disabledChargeType = item.chargeType?.toString()?.trim() === "";
        item.disabledValue = item?.value?.toString()?.trim() === "";
        item.disabledMinAmt = item?.minAmt?.toString()?.trim() === "";
        item.disabledMaxAmt = item?.maxAmt?.toString()?.trim() === "";
        if(item?.chargeType === "CUSTODY" || item?.chargeType==="PREPAYMENT" || groupDetails?.[i]?.chargeType === "PENAL_CHARGE_LTV"){
          item.disabledCriteriaAmt = item?.criteriaAmt?.toString()?.trim() === "";
        }else if(item?.chargeType === "PROCESSING_FEE"){
          item.disabledCriteriaBase = item?.data?.CRITERIA_BASE?.toString()?.trim() === "";
        }else{
          item.disabledCriteriaAmt = false;
          item.disabledCriteriaBase = false;
        }
        const updatedChargeDetails = item?.chargeDetails?.map((chargeItem) => {
          chargeItem.chargeNatureError = chargeItem?.chargeNature?.toString()?.trim() === "";
          chargeItem.valueError = chargeItem?.value?.toString()?.trim() === "";
          chargeItem.minAmountError = chargeItem?.minAmt?.toString()?.trim() === "";
          chargeItem.maxAmountError = chargeItem?.maxAmt?.toString()?.trim() === "";
          return chargeItem;
        });
        return {
          ...item,
          chargeDetails: updatedChargeDetails,
        };
      } else {
        return item; // If index is not in indicesToCheck, return the item as it is
      }
    });
    setGroupDetails(updatedGroupDetails);
    let hasErrors = false;

    updatedGroupDetails.forEach((item,index) => {
      if (i===index) {
        if (
          item?.name?.toString()?.trim() === "" ||
          item?.chargeNature?.toString()?.trim() === "" ||
          item?.chargeType?.toString()?.trim() === "" ||
          item?.value?.toString()?.trim() === "" ||
          item?.minAmt?.toString()?.trim() === "" ||
          item?.maxAmt?.toString()?.trim() === ""
        ) {
          hasErrors = true;
          return;
        }
  
        item?.chargeDetails?.forEach((chargeItem) => {
          if (
            chargeItem?.chargeNature?.toString()?.trim() === "" ||
            chargeItem?.value?.toString()?.trim() === "" ||
            chargeItem?.minAmt?.toString()?.trim() === "" ||
            chargeItem?.maxAmt?.toString()?.trim() === ""
          ) {
            hasErrors = true;
            return;
          }
        });
      }
    });

    const chargeType =groupDetails?.[i]?.chargeType; 
    if (
      (chargeType === "PREPAYMENT" && 
        groupDetails?.[i]?.criteriaAmt &&
        groupDetails?.[i]?.criteriaType && !hasErrors)  || (chargeType === "CUSTODY" && 
        groupDetails?.[i]?.criteriaAmt &&
        groupDetails?.[i]?.criteriaType && !hasErrors) || (chargeType === "PENAL_CHARGE_LTV" && 
        groupDetails?.[i]?.criteriaAmt &&
        groupDetails?.[i]?.criteriaType && !hasErrors) || ((chargeType !== "PREPAYMENT" || chargeType !== "CUSTODY" || chargeType !== "PENAL_CHARGE_LTV") && !hasErrors) 
    ) {
      return true;
    } else {
      return false;
    }
  }
  };
  const removeDisabledAndErrorFields = (array) => {
    return array.map(obj => {
        let newObj = {};
        Object.keys(obj).forEach(key => {
            if (!key.startsWith('disabled') && key !== 'chargeDetails') {
                newObj[key] = obj[key];
            }
        });
        if (obj.chargeDetails && Array.isArray(obj.chargeDetails)) {
            newObj.chargeDetails = obj.chargeDetails.map(chargeItem => {
                let newChargeItem = {};
                Object.keys(chargeItem).forEach(chargeKey => {
                    if (!chargeKey.endsWith('Error')) {
                        newChargeItem[chargeKey] = chargeItem[chargeKey];
                    }
                });
                return newChargeItem;
            });
        }
        return newObj;
    });
};
  const updateCharge = async (i) => {
    if (isValidated(i) && processingFeevPercentageValidation(i)) {
      setCallInProgress(true);
      const schemeChargesArr = removeDisabledAndErrorFields(groupDetails);
      let dataCriteria = {
        CRITERIA_BASE: schemeChargesArr?.[i]?.data?.CRITERIA_BASE
      };
      if (schemeChargesArr?.[i]?.chargeType === "PROCESSING_FEE" && enabledMinMAxPercentageFieldsCharges && schemeChargesArr?.[i]?.chargeNature === "PERCENTAGE" && Number(schemeChargesArr?.[i]?.value) <= 0) {
        const min = schemeChargesArr?.[i]?.data?.PROCESSINGFEE_PERCENTAGE?.MIN_PERCENTAGE || 0;
        const max = schemeChargesArr?.[i]?.data?.PROCESSINGFEE_PERCENTAGE?.MAX_PERCENTAGE || 0;
      
        dataCriteria.PROCESSINGFEE_PERCENTAGE = {
          MIN_PERCENTAGE: parseFloat(min),
          MAX_PERCENTAGE: parseFloat(max)
        };
      } else {
        if ("PROCESSINGFEE_PERCENTAGE" in dataCriteria) {
          delete dataCriteria.PROCESSINGFEE_PERCENTAGE;
        }
      }
      const result = await apiHandler({
        url: endpoint.ADMIN_SCHEME_CHARGE_UPDATE,
        method: "POST",
        authToken: authToken,
        data: {
          id: schemeChargesArr?.[i].id,
          name: schemeChargesArr?.[i].name,
          chargeNature: schemeChargesArr?.[i].chargeNature,
          chargeType: schemeChargesArr?.[i].chargeType,
          value: schemeChargesArr?.[i].value,
          minAmt: schemeChargesArr?.[i].minAmt,
          maxAmt: schemeChargesArr?.[i].maxAmt,
          chargeCalculationBase: schemeChargesArr?.[i].chargeCalculationBase,
          criteriaType:  schemeChargesArr?.[i]?.chargeType === "CUSTODY" ||
          schemeChargesArr?.[i]?.chargeType === "PREPAYMENT" ||
          schemeChargesArr?.[i]?.chargeType === "PENAL_CHARGE_LTV" ?  schemeChargesArr?.[i].criteriaType : "",
          criteriaAmt:schemeChargesArr?.[i]?.chargeType === "CUSTODY" ||
          schemeChargesArr?.[i]?.chargeType === "PREPAYMENT" ||
          schemeChargesArr?.[i]?.chargeType === "PENAL_CHARGE_LTV" ? schemeChargesArr?.[i].criteriaAmt: "",
          disbursalTime: schemeChargesArr?.[i].disbursalTime,
          gstApplicable: schemeChargesArr?.[i].gstApplicable,
          excludingGst: schemeChargesArr?.[i]?.excludingGst,
          loanSchemeCode: editMode,
          loanSchemeId: id,
          chargeDetails: schemeChargesArr?.[i]?.chargeDetails,
          graceDays: schemeChargesArr?.[i]?.chargeType === "PENAL_CHARGE_LTV" ? Number(schemeChargesArr?.[i].graceDays) : 0,
          data: dataCriteria,
        },
      });
      setCallInProgress(false);
      if (result?.data?.error_code) {
        toastUpdate("Error", result?.data?.user_description, true);

      } else {
        toastUpdate("Success", "Scheme Charge Update Successfully", true);
        editScheme();
        setEditIndex("");
      }
    }
  };

  const onClickDeleteData = (chargeIndex, groupIndexs) => {
    // Copy the entire groupDetails array
    let newArr = [...groupDetails];
    // Get the groupDetails object at the specified index
    let item = newArr[groupIndexs];
    // Map over the chargeDetails array of the groupDetails object
    const updatedChargeDetails = item.chargeDetails.filter((chargeDetail, index) => index !== chargeIndex);
    // Update the chargeDetails array of the groupDetails object
    item.chargeDetails = updatedChargeDetails;
    // Update the groupDetails array with the modified object
    newArr[groupIndexs] = item;
    // Update the state with the modified groupDetails array
    setGroupDetails(newArr);
  };
  const addData = () => {
    if (groupDetails?.length > schemeChargeLength && editMode) {
      createCharge(schemeChargeLength);
    } else {
      addNextRow();
    }
  };
  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        className={`${classes.inputFieldContainer} ${classes.chargeContainer}`}
      >
        <h2 className={classes.header}>Scheme Charges</h2>
        <div>
          {!viewPage &&
            editMode &&
            groupDetails?.length > 0 &&
            groupDetails?.[0]?.id > 0 && (
              <Button
                className={`${classes.button2} ${classes.schemeButton}`}
                onClick={() => (editIndex === 0 ? updateCharge(0) : editRow(0))}
                id="button"
              >
                {editIndex === 0 ? "Update Charges" : " Edit Charge"}
              </Button>
            )}
          {!viewPage &&
            editMode &&
            groupDetails?.length > 0 &&
            groupDetails?.[0]?.id > 0 && (
              <Button
                className={`${classes.button2} ${classes.schemeButton}`}
                onClick={() => deleteRow(0)}
                id="button"
              >
                Delete
              </Button>
            )}
          {!viewPage &&
            editMode &&
            groupDetails?.length > 0 &&
            groupDetails?.[0]?.id > 0 && (
              <Button
                className={`${classes.button2} ${classes.schemeButton}`}
                onClick={() => {
                  setEditIndex("");
                  editScheme();
                }}
                id="button"
              >
                Cancel
              </Button>
            )}
          {!viewPage && (
            <Button
              className={classes.button}
              onClick={() => {
                addData();
                // setLastIndex(lastIndex + 1);
              }}
              id="button"
            >
              {groupDetails?.length > schemeChargeLength && editMode
                ? "Save New Charge"
                : "Add New Charge"}
            </Button>
          )}
        </div>
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        {Array.apply(null, { length: lastIndex + 1 }).map((e, i) => {
        const isAllowedCharge =
          groupDetails?.[i]?.name === chargesNameList?.processingFee ||
          enabledGstApplicationForAllCharges;
    return(
          <Grid container className={classes.inputFieldContainer} key={i}>
            {i !== 0 && (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.buttonDelContainer}
              >
                {!viewPage && editMode && schemeChargeLength !== i && (
                  <Button
                    className={`${classes.button2} ${classes.schemeButton}`}
                    onClick={() =>
                      editIndex === i || schemeChargeLength === i
                        ? updateCharge(i)
                        : editRow(i)
                    }
                    id="button"
                  >
                    {editIndex === i || schemeChargeLength === i
                      ? "UpdateCharges"
                      : " Edit Charge"}
                  </Button>
                )}
                {!viewPage && schemeChargeLength !== i && (
                  <Button
                    className={`${classes.button2} ${classes.schemeButton}`}
                    onClick={() => deleteRow(i)}
                    id="button"
                  >
                    Delete
                  </Button>
                )}
                {!viewPage && editMode && schemeChargeLength !== i && (
                  <Button
                    className={`${classes.button2} ${classes.schemeButton}`}
                    onClick={() => {
                      setEditIndex("");
                      editScheme();
                    }}
                    id="button"
                  >
                    Cancel
                  </Button>
                )}
                {!viewPage && editMode && schemeChargeLength === i && (
                  <Button
                    className={`${classes.button2} ${classes.schemeButton}`}
                    onClick={() => {
                      setLastIndex(lastIndex - 1);
                      setGroupDetails((prev) => prev.filter((p, j) => i !== j));
                    }}
                    id="button"
                  >
                    Delete
                  </Button>
                )}
                {!viewPage && editMode && schemeChargeLength === i && (
                  <Button
                    className={`${classes.button2} ${classes.schemeButton}`}
                    onClick={() => {
                      addData();
                      // setLastIndex(lastIndex + 1);
                    }}
                    id="button"
                  >
                    Save New Charge
                  </Button>
                )}
              </Grid>
            )}
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomSelectNew
                label="Charges"
                error={groupDetails?.[i]?.disabledName ? true : false}
                value={groupDetails?.[i]?.name}
                setState={handleChange}
                data={chargesApiList}
                id={`scheme_charges${i}`}
                disabled={
                  editIndex === i ||
                  schemeChargeLength === i ||
                  schemeChargeLength === i
                    ? false
                    : editMode
                }
                // setError={setChargeNameState}
                index={i}
                type="newSchemeChargeName"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomSelectNew
                label="ChargeNature"
                error={groupDetails?.[i]?.disabledChargeNature ? true : false}
                value={groupDetails?.[i]?.chargeNature}
                setState={handleChange}
                id={`scheme_chargenature${i}`}
                disabled={
                  editIndex === i || schemeChargeLength === i ? false : editMode
                }
                data={chargeNatureList}
                setError={setChargeNatureState}
                index={i}
                type="newSchemeCharge"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomSelectNew
                label="ChargeType"
                error={chargeTypeState ? true : false}
                value={groupDetails?.[i]?.chargeType}
                setState={handleChange}
                data={chargesApiList}
                id={`scheme_chargetype${i}`}
                disabled
                setError={setChargeTypeState}
                index={i}
                type="newSchemeChargeType"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="Value"
                required
                error={groupDetails?.[i]?.disabledValue ? true : false}
                value={groupDetails?.[i]?.value}
                setState={handleChange}
                id={`scheme_value${i}`}
                disabled={
                 (groupDetails?.[i]?.data?.PROCESSINGFEE_PERCENTAGE?.MIN_PERCENTAGE !== "" && groupDetails?.[i]?.data?.PROCESSINGFEE_PERCENTAGE?.MIN_PERCENTAGE > 0) || (groupDetails?.[i]?.data?.PROCESSINGFEE_PERCENTAGE?.MAX_PERCENTAGE !== "" && groupDetails?.[i]?.data?.PROCESSINGFEE_PERCENTAGE?.MAX_PERCENTAGE > 0) || (editIndex === i || schemeChargeLength === i ? false : editMode)
                }
                setError={setValueSetState}
                index={i}
                type="newSchemeCharge"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="MinAmount"
                required
                disabled={
                  groupDetails?.[i]?.chargeNature === "FLAT"
                    ? true
                    : false || editIndex === i || schemeChargeLength === i
                    ? false
                    : editMode
                }
                id={`scheme_minamount${i}`}
                error={groupDetails?.[i]?.disabledMinAmt ? true : false}
                value={
                  groupDetails?.[i]?.chargeNature === "FLAT"
                    ? groupDetails?.[i]?.value
                    : groupDetails?.[i]?.minAmt
                }
                setState={handleChange}
                setError={setMinAmountState}
                index={i}
                type="newSchemeCharge"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="MaxAmount"
                required
                error={groupDetails?.[i]?.disabledMaxAmt ? true : false}
                disabled={
                  groupDetails?.[i]?.chargeNature === "FLAT"
                    ? true
                    : false || editIndex === i || schemeChargeLength === i
                    ? false
                    : editMode
                }
                id={`scheme_maxamount${i}`}
                value={
                  groupDetails?.[i]?.chargeNature === "FLAT"
                    ? groupDetails?.[i]?.value
                    : groupDetails?.[i]?.maxAmt
                }
                setState={handleChange}
                index={i}
                setError={setMaxAmountState}
                type="newSchemeCharge"
              />
            </Grid>
            {groupDetails?.[i]?.chargeNature === "PERCENTAGE" && groupDetails?.[i]?.chargeType === "PROCESSING_FEE" && enabledMinMAxPercentageFieldsCharges &&
            <>
              <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                <CustomeTextField
                  label="Min Percentage"
                  required
                  disabled={(
                    groupDetails?.[i]?.value !== "" && Number(groupDetails?.[i]?.value) > 0
                  ) || ( editIndex === i ||schemeChargeLength === i ? false : editMode) }
                  id={`scheme_minamount${i}`}
                  value={groupDetails?.[i]?.data?.PROCESSINGFEE_PERCENTAGE?.MIN_PERCENTAGE}
                  setState={handleChange}
                  index={i}
                  setError={setMinPercentageState}
                  type="percentageNumber"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                <CustomeTextField
                  label="Max Percentage"
                  required
                  disabled={(editIndex === i || schemeChargeLength === i ? false : editMode) || (
                    groupDetails?.[i]?.value !== "" && Number(groupDetails?.[i]?.value) > 0
                  )}
                  id={`scheme_maxamount${i}`}
                  value={groupDetails?.[i]?.data?.PROCESSINGFEE_PERCENTAGE?.MAX_PERCENTAGE}
                  setState={handleChange}
                  index={i}
                  setError={setMaxPercentageState}
                  type="percentageNumber"
                />
              </Grid>
            </>
            }
            {groupDetails?.[i]?.chargeType === "PROCESSING_FEE" && enableProcessingFeeCriteriaTypeFlag && (
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomSelectNew
                label="Criteria Base"
                // error={chargeTypeState ? true : false}
                value={groupDetails?.[i]?.data?.CRITERIA_BASE}
                setState={handleChange}
                data={criteriaBaseData}
                id={`criteria_base${i}`}
                disabled={
                  editIndex === i || schemeChargeLength === i ? false : editMode
                }
                // setError={setChargeTypeState}
                index={i}
                type="newSchemeChargeName"
              />
            </Grid>
              )
            }
            {(groupDetails?.[i]?.chargeType === "CUSTODY" ||
              groupDetails?.[i]?.chargeType === "PREPAYMENT" ||
              groupDetails?.[i]?.chargeType === "PENAL_CHARGE_LTV") && (
              <>
                <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                  <CustomeTextField
                    label="Criteria Value"
                    required
                    value={
                      groupDetails[i].chargeType === "CUSTODY" || groupDetails?.[i]?.chargeType === "PENAL_CHARGE_LTV"
                        ? "LTV"
                        : "PART PAYMENT AMOUNT"
                    }
                    disabled={true}
                    index={i}
                    id={`scheme_criteria_value${i}`}
                    type="newSchemeCharge"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                  <CustomeTextField
                    label="Criteria"
                    required
                    error={
                        (groupDetails?.[i]?.disabledCriteriaAmt || criteriaAmountState) ? true : false
                    }
                    value={groupDetails?.[i]?.criteriaAmt}
                    setState={handleChange}
                    disabled={
                      editIndex === i || schemeChargeLength === i
                        ? false
                        : editMode
                    }
                    id={`scheme_criteria_amount${i}`}
                    setError={setCriteriaAmountState}
                    index={i}
                    type="newSchemeCharge"
                  />
                </Grid>
              </>
            )}
            {groupDetails?.[i]?.chargeType === "PENAL_CHARGE_LTV" && (
              <>
                <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                  <CustomeTextField
                    label="Grace Days"
                    required
                    value={ groupDetails[i].graceDays  }
                    index={i}
                    id={`grase_days${i}`}
                    type="newSchemeCharge"
                    setState={handleChange}
                    disabled={
                      editIndex === i || schemeChargeLength === i
                        ? false
                        : editMode
                    }
                  />
                </Grid>
              </>
            )}
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={classes.fieldContaienr}
              style={{ display: "flex", flexWrap: "wrap" }}
            >
              <Grid item xs={12} sm={6} md={6}>
                <span style={{ fontWeight: "bold" }}>
                  {" "}
                  <input
                    id="selectAll"
                    type="checkbox"
                    checked={groupDetails?.[i]?.disbursalTime}
                    disabled={
                      editIndex === i || schemeChargeLength === i
                        ? false
                        : editMode
                    }
                    className={classes.checkboxInput}
                    onChange={(e) =>
                      handleChange(e.target.checked, i, "Checked")
                    }
                  />{" "}
                  Disbursal Time
                </span>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <span style={{ fontWeight: "bold" }}>
                  {" "}
                  <input
                    id="selectAll"
                    type="checkbox"
                    checked={groupDetails?.[i]?.gstApplicable}
                    disabled={!(isAllowedCharge)}
                    className={classes.checkboxInput}
                    onChange={(e) =>
                      handleChange(e.target.checked, i, "GSTChecked")
                    }
                  />{" "}
                  GST Applicable
                </span>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <span style={{ fontWeight: "bold" }}>
                  {" "}
                  <input
                    id="selectAll"
                    type="checkbox"
                    checked={groupDetails?.[i]?.excludingGst}
                    disabled={true}
                    className={classes.checkboxInput}
                    onChange={(e) =>
                      handleChange(e.target.checked, i, "excludeGst")
                    }
                  />{" "}
                  Exclude GST
                </span>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              {(groupDetails?.[i]?.chargeType === "CLOSURE" ||
                groupDetails?.[i]?.chargeType === "PREPAYMENT") && !viewPage && (
                <div className={classes.leftButtonScheme}>
                  <Button
                    className={classes.button}
                    onClick={() => {
                      addChargesData(i, groupDetails?.[i]?.chargeDetails?.length);
                    }}
                    disabled={ editIndex !== i && editMode && i !== schemeChargeLength }
                    id="button"
                  >
                    Add Days Wise Charge
                  </Button>
                </div>
              )}
            </Grid>
          <SchemeChargesDetails viewPage={viewPage} editMode={editMode}
          editIndex={editIndex} chargeDetails={groupDetails[i]?.chargeDetails} classes={classes} chargeNatureList={chargeNatureList} onClickDeleteData={onClickDeleteData} handleChange={handleChange} groupindex ={i} schemeChargeLength={schemeChargeLength}/>
          </Grid>
          )
        })}
      </Grid>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
       {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </>
  );
};
export default SchemeCharge;
